import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  type AccordionProps,
  Box,
  Heading,
  Icon,
} from "@chakra-ui/react";
import { CopyButton } from "@components/CopyButton";
import { FileCopyIcon } from "@icons";
import { useColor } from "@styles/useColor";
import { type UnifiedNFTBalance } from "@umami/chains";

export const JSONAccordion = ({ nft, ...props }: { nft: UnifiedNFTBalance } & AccordionProps) => {
  const color = useColor();

  const formattedJSON = JSON.stringify(nft.metadata, null, 2);

  return (
    <Accordion allowToggle {...props}>
      <AccordionItem data-testid="json-section">
        <AccordionButton>
          <Heading flex="1" color={color("900")} textAlign="left" size="lg">
            JSON
          </Heading>
          <AccordionIcon />
        </AccordionButton>

        <AccordionPanel>
          <Box position="relative">
            <CopyButton
              position="absolute"
              top="2px"
              right="-6px"
              _hover={{ color: color("700") }}
              aria-label="Copy JSON"
              value={formattedJSON}
              variant="iconButton"
            >
              <Icon as={FileCopyIcon} width="24px" height="24px" />
            </CopyButton>
          </Box>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              padding: "18px",
              color: color("700"),
              fontFamily: "JetBrains Mono",
              fontSize: "12px",
              borderRadius: "8px",
              backgroundColor: color("100"),
            }}
          >
            {formattedJSON}
          </pre>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
